<template>
    <div class="return-list-filter">
        <div class="search-container filter-container">
            <div class="filter-title">Поиск</div>
            <input type="text" v-model="queryString" placeholder="Название товара или артикул товара или ID заказа">
        </div>
        <div class="date-container filter-container">
            <div class="date-container-start">
                <div class="filter-title">Начало</div>
                <input type="date" v-model="dateStart">
            </div>
            <div class="date-container-end">
                <div class="filter-title">Конец</div>
                <input type="date" v-model="dateEnd">
            </div>
        </div>
        <div class="btn-filter-wrapper">
            <div class="btn-cancel btn_new" @click="clearFilter">Отмена</div>
            <div class="btn-filter btn_new" @click="applyFilter">Применить</div>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'

  export default {
    name: 'return-list-filter',
    computed: {
      ...mapGetters('return', [
        'filterQueryString',
        'filterDateStart',
        'filterDateEnd'
      ]),
      queryString: {
        get: function () {
          return this.filterQueryString
        },
        set: function (val) {
          this.setFilterQueryString(val)
        }
      },
      dateStart: {
        get: function () {
          if (this.filterDateStart === 0) {
            return ''
          } else {
            let date = new Date(this.filterDateStart * 1000)
            return this.dateFormat(date)
          }
        },
        set: function (val) {
          if (val === '') {
            this.setFilterDateStart(0)
          } else {
            let date = new Date(val)
            let unix = date.getTime() / 1000
            this.setFilterDateStart(unix)
          }
        }
      },
      dateEnd: {
        get: function () {
          if (this.filterDateEnd === 0) {
            return ''
          } else {
            let date = new Date(this.filterDateEnd * 1000)
            return this.dateFormat(date)
          }
        },
        set: function (val) {
          if (val === '') {
            this.setFilterDateEnd(0)
          } else {
            let date = new Date(val)
            let unix = date.getTime() / 1000
            this.setFilterDateEnd(unix)
          }
        }
      }
    },
    methods: {
      ...mapMutations('return', [
        'setFilterQueryString',
        'setFilterDateStart',
        'setFilterDateEnd',
        'setOffset',
        'clearOrders',
        'setHasMore'
      ]),
      ...mapActions('return', [
        'fetchOrders'
      ]),
      dateFormat: function (date) {
        let days = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()

        if (days < 10) {
          days = '0' + days
        }

        if (month < 10) {
          month = '0' + month
        }

        return `${year}-${month}-${days}`
      },
      clearFilter: function () {
        this.setFilterQueryString('')
        this.setFilterDateStart(0)
        this.setFilterDateEnd(0)
        this.setHasMore({hasMore: true})
        this.setOffset({offset: 0})
        this.clearOrders()
        this.fetchOrders()
      },
      applyFilter: function () {
        this.setHasMore({hasMore: true})
        this.setOffset({offset: 0})
        this.clearOrders()
        this.fetchOrders()
      }
    }
  }
</script>

<style lang="scss" scoped>
    .return-list-filter{
        %btn{
            cursor: pointer;
            padding-left: 15px;
            padding-right: 15px;
            margin-left: 20px;
        }

        .btn-cancel{
            @extend %btn;
        }

        .btn-filter{
            @extend %btn;
        }

        .btn-filter-wrapper{
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
        }

        input{
            padding-left: 12px;
            width: 100%;
            transition: all .6s ease;
            border: 1px solid #dadada;
            background-color: #fff;
            height: 40px;
            &:valid{
                border-color: #00a460;
            }
            &:hover{
                border-color: #00b770;
            }
        }

        .filter-title{
            font-weight: 700;
        }

        .filter-container{
            margin-top: 10px;
        }

        .date-container{
            display: flex;
            justify-content: space-between;
            &>div{
                flex-grow: 1;
            }

            &-start{
                margin-right: 10px;
            }

            &-end{
                margin-left: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Personal/Return/ReturnListFilter.vue